import React from 'react'
import PropTypes from 'prop-types'
import { graphql, StaticQuery, Link } from 'gatsby'

class BlogRoll extends React.Component {
  render () {
    const { data } = this.props
    const { edges: posts } = data.allMarkdownRemark

    return (
      <section id='blog' className='section' style={{ background: '#161c27', position: 'relative' }}>

        <div className='container'>
          <div className='columns is-multiline is-centered'>
            <div className='column is-12 has-text-centered'>
              <div style={{ position: 'relative' }}>
                <h1 className='title is-2' style={{ marginBottom: '3rem' }}>Stories</h1>
                <div className='headline' />
              </div>
            </div>


            {posts && (posts
              .map(({ node: post }) => (
                <div
                  className='is-parent column is-4'
                  key={post.id}
                >
                  <article style={{ padding: '0', boxShadow: '0 0 10px rgba(0,0,0,.5)', maxWidth: '500px', margin: '0 auto' }}>
                    <div style={{ position: 'relative' }}>
                      <Link className='title is-size-4' style={{ position: 'absolute', width: '100%', color: 'white', background: 'rgba(0,0,0,.5)', padding: '15px', overflow: 'hidden' }} to={post.fields.slug}>
                        {post.frontmatter.title}
                        <div className='hoverLine'></div>
                      </Link>
                      <Link to={post.fields.slug}>
                        <img src={post.frontmatter.image.childImageSharp.fluid.src} alt={post.frontmatter.title}

                        />
                      </Link>


                    </div>
                    <p style={{ padding: '10px', hyphens: 'auto', textAlign: 'justify', color: '#fff' }}>
                      {post.excerpt}
                      <br />
                      <br />
                      <Link className='button is-rounded is-normal is-outlined is-primary' to={post.fields.slug}>
                      zur Story →
                      </Link>
                    </p>
                  </article>
                </div>
              )))}

              {/*
              <div className='column is-12 has-text-centered'>
                <Link className='button is-primary is-rounded' to='/blog'>
                  alle Einträge
                </Link>
              </div>
              */}
          </div>
        </div>
      </section>

    )
  }
}

BlogRoll.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.array,
    }),
  }),
}

export default () => (
  <StaticQuery
    query={graphql`
    query BlogRollQuery {
      allMarkdownRemark(
        limit: 1,
        sort: { order: DESC, fields: [frontmatter___date] },
        filter: { frontmatter: { templateKey: { eq: "blog-post" } }}
      ) {
        edges {
          node {
            excerpt(pruneLength: 100)
            id
            fields {
              slug
            }
            frontmatter {
              image {
                childImageSharp {
                  fluid(maxWidth: 500, quality: 80) {
                    ...GatsbyImageSharpFluid_withWebp
                    presentationWidth
                  }
                }
              }
              title
              templateKey
              date(formatString: "DD.MM.YYYY")
            }
          }
        }
      }
    }
    `}
    render={(data, count) => (
      <BlogRoll data={data} count={count} />
    )}
  />
)
